<template>
  <v-container>
    <v-row align="center" justify="end" no-gutters class="mb-2">
      <v-btn :to="{ name: 'InventoryViewer', params: { date: date } }">
        <v-icon small left>fa-external-link-alt</v-icon>
        Exporter
      </v-btn>
    </v-row>
    <v-card>
      <v-card-text>
        <InventoryHistory :date.sync="date"></InventoryHistory>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { InventoryHistory } from "../components";
export default {
  name: "InventoryHistoryIndex",
  components: {
    InventoryHistory
  },
  computed: {
    ...mapGetters([
      "getStoreId",
      "getOrganisationId",
      "getIsAdmin",
      "getInventoryTemplates"
    ])
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  data() {
    return {
      date: null
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.template = [];
        this.templateId = null;
        await Promise.all([
          this.$store.dispatch("loadRecipes", {
            organisation: this.getOrganisationId
          }),
          this.$store.dispatch("loadProducts", {
            organisation: this.getOrganisationId
          }),
          this.$store.dispatch("loadInventoryRecords", {
            store: this.getStoreId,
            latest: true
          }),
          this.$store.dispatch("loadInventoryTemplates", {
            store: this.getStoreId
          }),
          this.$store.dispatch("loadWasteCauses", {
            store: this.getStoreId
          })
        ]);
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    getStoreId() {
      this.getData();
    },
    getOrganisationId() {
      this.getData();
    }
  }
};
</script>

<style></style>
